import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertCmp, AlertController, ModalController, ToastController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import * as moment from 'moment';
import { CalendarPage } from '../../../calendar/calendar';
import { PopupPage } from '../../../popup/popup';
import { LoadimportedPage } from '../loadimported/loadimported';
import { SuccsavedorderPage } from '../../../succsavedorder/succsavedorder';

/**
 * Generated class for the NeworderindoorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-neworderindoor',
  templateUrl: 'neworderindoor.html',
})
export class NeworderindoorPage {
  @ViewChild('mySearchInput') mySearchInput;
  Title = ''
  preddata = []

  startDateA: any = new Date()
  startDateStrA: any = moment(new Date()).format(this.gn.user.DFormat)
  selectedTime = new Date().getHours() + 1 + ":00";
  selectedQuantity = '1'
  selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleID = -1;
  RouteTitle = ''

  EditId = -1
  EditType = 'new'

  ref;
  onlyloc = false;
  se: any
  cntdata = 0;
  loadingData: boolean = false
  loadingImport: boolean = false

  article: string = ''
  articleid = -1
  selectedCartsIds = []
  selectedCarts = '--- ' + this.dic.l["chooseCarts"] + ' ---';
  idxCoDriver = ''
  Hour: any
  Minutes: any
  Buyer = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public modalCtrl: ModalController, public toastCtrl: ToastController) {
    this.article = this.dic.l["chooseArticle"]
    this.Title = this.dic.l["newWorkOrder"]
    var tmpid = this.navParams.get('id')
    if (tmpid != null) {
      this.EditId = tmpid
      this.EditType = this.navParams.get('edittype')
      console.log(this.EditType, 'this.EditType')
      this.ref = this.navParams.get('ref')
      this.Title = this.dic.l['editO'] + ': ' + tmpid
      //this.preddata = this.navParams.get('preddata')

      //edit na predefiniran nalog
      if (this.EditType == 'pre') {
        this.RouteTitle = this.navParams.get('preddata').name

        this.startDateA = this.navParams.get('preddata').startdate
        this.startDateStrA = moment(this.navParams.get('preddata').startdate).format(this.gn.user.DFormat)

        this.selectedTime = moment(this.navParams.get('preddata').startdate).format('HH:mm')
        this.selectedVehicleName = this.navParams.get('preddata').vehicle
        this.selectedVehicleID = this.navParams.get('preddata').vehicleid

        this.selectedQuantity = this.navParams.get('preddata').quanity
        //edit na nalog od pregled na nalozi
      } else {
        // presmetka za realno vreme na totaltime
        this.RouteTitle = this.navParams.get('routedata').routetitle
        this.startDateA = this.navParams.get('routedata').startdate
        this.startDateStrA = moment(this.navParams.get('routedata').startdate).format(this.gn.user.DFormat)
        this.selectedTime = moment(this.navParams.get('routedata').startdate).format('HH:mm')
        this.selectedVehicleName = this.navParams.get('routedata').vozilo //vehicle
        this.selectedVehicleID = this.navParams.get('routedata').vehicleid
        this.selectedQuantity = this.navParams.get('routedata').quanity
      }
    }
    // console.log('Nalog za editiranje: ' + this.EditId)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NeworderindoorPage');
    this.importOrders();
  }

  importOrders() {
    this.loadingImport = false
    var _that = this
    this.gn._Post('/api/importorders', { refreshall: this.gn.crypt(false), cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that.loadingImport = true
    })
  }

  openDatePopup(_ev) {
    if (this.EditId != -1) return false;
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: this.startDateA, cb: function (d) {
        // console.log(d)
        _that.startDateA = d;
        _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
      }
    })
    popover.present({ ev: _ev });
  }
  openTimePopup(_ev) {
    if (this.EditId != -1) return false;
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'time', selected: [], callback: function (_text, _ids) {
        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedTime = _text;

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  openQuantityPopup(_ev) {
    if (this.EditId != -1) return false;
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'quantity', selected: [], callback: function (_text, _ids) {
        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedQuantity = _text;

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }


  openArticlePopup(_ev) {
    if (this.EditId != -1) return false;
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'routing-articles', selected: [], callback: function (_text, _ids) {
        _that.articleid = _ids
        _that.article = _text
      }
    }, { cssClass: 'popover-content-articles' });
    popover.present({ ev: _ev });
  }

  selectCarts(_ev) {
    var _that = this
    this.gn._Post('/api/gn/getavailablecarts', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      let popover = _that.popoverCtrl.create(PopupPage, {
        type: 'routing-carts', selected: '', arrayData: _data, selCartsId: _that.selectedCartsIds, callback: function (_text, _ids) {
          var tmp = []
          _that.selectedCartsIds = []

          for (let ii = 0; ii < _ids.length; ii++) {
            if (_ids[ii].ch) {
              for (var i = 0; i < _data.length; i++) {
                if (_data[i].id + '' == _ids[ii].id + '') {
                  tmp.push(_data[i].name)
                  _that.selectedCartsIds.push(_ids[ii].id)
                  _that.idxCoDriver += ii + ';'
                }
              }

            }
          }
          _that.selectedCarts = tmp.join(', ')
        }
      });
      popover.present({ ev: _ev });
    })
  }

  clearNalog() {
    // console.log('funkcija prv red')
    if (this.onlyloc == false) {
      this.startDateA = new Date()
      this.startDateStrA = moment(new Date()).format(this.gn.user.DFormat)
      this.selectedTime = new Date().getHours() + 1 + ":00";
      this.selectedQuantity = '1'

      this.RouteTitle = ''

      this.article = this.dic.l["chooseArticle"]
      this.articleid = -1
      this.selectedCartsIds = []
      this.selectedCarts = '--- ' + this.dic.l["chooseCarts"] + ' ---';
      this.EditId = -1
      this.Hour = ''
      this.Minutes = ''
    }
  }

  setVariables(nid, totaltime, totalkm) {
    var _nid = nid
    var _that = this
    var timeDuration = this.Hour * 3600 + this.Minutes * 60

    var _dt = moment(_that.startDateA).format('YYYY-MM-DD') + ' ' + _that.selectedTime

    var _dat = {
      dt: _that.gn.crypt(_dt),
      title: _that.gn.crypt(_that.RouteTitle),
      id: _that.gn.crypt(_that.EditId),
      cid: _that.gn.crypt(_that.gn.user.ClientId),
      uid: _that.gn.crypt(_that.gn.user.UserId),
      aid: _that.gn.crypt(_that.articleid),
      cartids: _that.gn.crypt(_that.selectedCartsIds),
      duration: _that.gn.crypt(timeDuration),
      buyer: _that.gn.crypt(_that.Buyer),
      quantity: _that.gn.crypt(_that.selectedQuantity)
    }


    // var _that = _that
    //raboti samo save na edit predefiniran nalog
    _that.gn._Post('/api/gn/saverouteindoor', _dat, function (_data) {
      _that.loadingData = false;
      _that.gn.tfBtn = false;

      // let alertModal = _that.modalCtrl.create(SuccsavedorderPage, {
      //   id: _that.navParams.get("id") == undefined ? _data.nalid : _that.navParams.get("id"),
      //   nid: _nid,
      //   cb: function () {
      _that.onlyloc = false;
      _that.clearNalog();

      let toast = _that.toastCtrl.create({
        message: _that.dic.l["saveWorkOrder"],
        duration: 3000,
        position: 'top'
      });
      toast.present();

      //     if (_nid != -1) {
      //       _that.ref.mdl.dismiss();
      //       var cb = _that.navParams.get('cb')
      //       cb();
      //     }
      //   }
      // }, { cssClass: "modal-fullscreen5" });
      // alertModal.present();
    })

  }

  saveNalog(_nid) {
    if (this.RouteTitle == '') {
      const alert = this.alertCtrl.create({
        subTitle: this.dic.l["mustOrderName"],
        buttons: [this.dic.l['ok']]
      });
      alert.present();
      return
    }

    if (this.gn.user.ClientId == 803) {
      this.Hour = +this.Hour
      this.Minutes = +this.Minutes
      console.log(this.Minutes, 'this.Minutes')

      if (isNaN(this.Hour)) this.Hour = 0
      if (isNaN(this.Minutes)) this.Minutes = 0


      if (isNaN(this.Hour) && (this.Hour % 1 != 0) && this.Hour >= 1) {
        const alert = this.alertCtrl.create({
          subTitle: this.dic.l["mustbenumberhour"],
          buttons: [this.dic.l['ok']]
        });
        alert.present();
        return
      }

      if (isNaN(this.Minutes) && (this.Minutes % 1 != 0)) {
        const alert = this.alertCtrl.create({
          subTitle: this.dic.l["mustbenumbermin"],
          buttons: [this.dic.l['ok']]
        });
        alert.present();
        return
      }

      var ContinuteFlag = false

      if (this.Minutes == 0 && this.Hour != 0) {
        ContinuteFlag = true
      }
      if (this.Minutes == 0 && this.Hour == 0) {
        const alert = this.alertCtrl.create({
          subTitle: this.dic.l["mustenterduration"],
          buttons: [this.dic.l['ok']]
        });
        alert.present();
        return
      }
      if (ContinuteFlag == false) {
        if (this.Minutes < 1 == false && this.Minutes > 60) {
          const alert = this.alertCtrl.create({
            subTitle: this.dic.l["mustbenumbermin"],
            buttons: [this.dic.l['ok']]
          });
          alert.present();
          return
        }
      }


      if (this.Buyer == '') {
        const alert = this.alertCtrl.create({
          subTitle: this.dic.l["mustBuyerName"],
          buttons: [this.dic.l['ok']]
        });
        alert.present();
        return
      }
    }



    this.gn.tfBtn = true;
    this.setVariables(_nid, 0, 0)
  }



  openImportedForDownload(_pre, _onlyloc) {
    //_onlyloc = true - Prevzemi lokacii
    //_onlyloc = false - Prevzemi nalog
    this.onlyloc = _onlyloc;
    var _that = this
    let profileModal = this.modalCtrl.create(LoadimportedPage, {
      onlyloc: _onlyloc,
      cb: function (_id) {
        //debugger
        _that.doLoadImported(_id)
      }
    });
    profileModal.present();
  }

  doLoadImported(_nid) {
    //debugger
    this.clearNalog();
    this.EditId = _nid

    var _that = this
    this.gn._Post('/api/gn/getImportedRouteOne', { cid: this.gn.crypt(this.gn.user.ClientId), nid: this.gn.crypt(_nid) }, function (_data) {
      if (_that.onlyloc == false) {
        _that.RouteTitle = _data[0].title;
        _that.article = _data[0].article;
        _that.articleid = _data[0].articleid;
        _that.startDateA = _data[0].dt
        _that.startDateStrA = moment(_data[0].dt).format(_that.gn.user.DFormat)
        _that.selectedTime = moment(_data[0].dt).format('HH:mm')
        //alert('Popolni route')
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/neworderindoor/neworderindoor.ts